import React, { useEffect, useState } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import useOperationStepValues from 'router/data/useOperationStepValues';
import SelectField from 'components/SelectField';
import validations from 'validations';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import utils from 'utils';
import MinusIcon from 'icons/Minus.icon';
import PlusIcon from 'icons/Plus.icon';
import { Button } from 'ncoded-component-library';

import './IndustryField.styles.scss';
import './IndustryField.styles.responsive.scss';

const IndustryField: React.FC = () => {
  const { industrySelectOptions } = useOperationStepValues();
  const { t } = useTranslation();
  const { change } = useForm();
  const {
    values: { otherIndustry, industry },
  } = useFormState();

  const [isOther, setIsOther] = useState(!!otherIndustry);

  useEffect(() => {
    if (otherIndustry) {
      change('industry', undefined);
    }
  }, [change, otherIndustry]);

  useEffect(() => {
    if (industry) {
      setIsOther(false);
      change('otherIndustry', undefined);
    }
  }, [change, industry]);

  return (
    <div className="industry-field">
      <Field
        name="industry"
        options={industrySelectOptions}
        component={SelectField}
        validate={!otherIndustry ? validations.required() : utils.noop()}
        placeholder={t('startTypingIndustry')}
        searchable
      />
      <Button
        variant="link"
        className="industry-field__other-button"
        onClick={() => setIsOther((prev) => !prev)}
      >
        {isOther ? <MinusIcon /> : <PlusIcon />}
        {t('industryOtherButton')}
      </Button>
      {isOther && (
        <Field
          name="otherIndustry"
          label={t('otherIndustryLabel')}
          component={InputField}
          validate={validations.required()}
          required
        />
      )}
    </div>
  );
};

export default IndustryField;
